
export default {
    props: ['items'],
    data() {
        return {
            BarTips:{},
            growthValue:'',
            leftImg:'',
            rightImg:'',
            BgBar:{},
            Bar:{},
            tipsLeft:'',
            barWidth:'',
        }
    },
    computed: {
        
    },
    created() {
        this.BarTips[this.items.mCBarTips]=true;
        this.growthValue=this.items.growthValue;
        this.leftImg=require("../../images/"+this.items.leftImg);
        this.rightImg=require("../../images/"+this.items.rightImg);
        this.BgBar[this.items.mCBgBar]=true;
        this.Bar[this.items.mCBar]=true;
        this.tipsLeft=this.items.value*0.84;
        this.barWidth=this.items.value;
        
    },
    mounted() {
    },
    methods: {

        // 显示签到弹框
        showRule(){
            this.showRuleFlag=true;
        },
        // 关闭签到弹框
        closeRule(){
            this.showRuleFlag=false;
        }
    }
}